import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    BarChartOutlined,
    ToolOutlined,
    UnorderedListOutlined
} from '@ant-design/icons';
import '../styles/InstallerWorkHub.css';

const ITEMS = [
    {
        key: 'work',
        path: '/installer/work',
        label: 'Работа',
        icon: <UnorderedListOutlined />
    },
    {
        key: 'tmc',
        path: '/installer/tmc',
        label: 'ТМЦ',
        icon: <ToolOutlined />
    },
    {
        key: 'timesheet',
        path: '/installer',
        label: 'Табель',
        icon: <BarChartOutlined />
    }
];

const InstallerBottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const activeKey = (() => {
        if (location.pathname === '/installer/tmc') {
            return 'tmc';
        }
        if (
            location.pathname === '/installer/work' ||
            location.pathname.startsWith(
                '/installer/work/'
            )
        ) {
            return 'work';
        }
        if (location.pathname === '/installer') {
            return 'timesheet';
        }
        return null;
    })();

    return (
        <nav className="installer-bottom-nav">
            {ITEMS.map(item => (
                <button
                    key={item.key}
                    type="button"
                    className={`installer-bottom-nav__btn${
                        activeKey === item.key
                            ? ' is-active'
                            : ''
                    }`}
                    onClick={() =>
                        navigate(item.path)
                    }
                >
                    {item.icon}
                    {item.label}
                </button>
            ))}
        </nav>
    );
};

export default InstallerBottomNav;
